import { ExecutionData } from "../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { TextFormControl } from "../Controls/Web/TextFormControl";
import { MultiLineTextEditFormControl } from "../Controls/Web/MultiLineTextEditFormControl";
import { CheckboxFormControl } from "../Controls/Web/CheckboxFormControl";
import { SelectFormControl } from "../Controls/Web/SelectFormControl";
import { HeadingFormControl } from "../Controls/Web/HeadingFormControl";
import { LabelFormControl } from "../Controls/Web/LabelFormControl";
import { ButtonFormControl } from "../Controls/Web/ButtonFormControl";
import { LinkFormControl } from "../Controls/Web/LinkFormControl";
import { SwitchFormControl } from "../Controls/Web/SwitchFormControl";
import { CheckboxListFormControl } from "../Controls/Web/CheckboxListFormControl";
import { RatingFormControl } from "../Controls/Web/RatingFormControl";

import { InlineTextEditFormControl } from "../Controls/Web/InlineTextEditFormControl";
import { MultiInlineTextEditFormControl } from "../Controls/Web/MultiInlineTextEditFormControl";

import { XColumnContainer, XColumnContainerColumn, XHStackContainer, XStackContainer } from "../Containers";

import { RadioGroupFormControl } from "../Controls/Web/RadioGroupFormControl";
import { FormConfiguration } from "../FormConfiguration";
import { DatePickerFormControl } from "../Controls/Web/DatePickerFormControl";
import { TimePickerFormControl } from "../Controls/Web/TimePickerFormControl";
import { NumberFormControl } from "../Controls/Web/NumberFormControl";
import { SliderFormControl } from "../Controls/Web/SliderFormControl";
import { ButtonGroupFormControl } from "../Controls/Web/ButtonGroupFormControl";
import { TagGroupFormControl } from "../Controls/Web/TagGroupFormControl";
import { ButtonControlSize, WidthUnitInterface } from "../Utilities/FormDesignConstants";
import { DefaultOnOff } from "../Utilities/DefaultOnOff";
import { ListEntryFormControl } from "../Controls/Web/ListEntryFormControl";
import { ValueSliderFormControl } from "../Controls/Web/ValueSliderFormControl";
import { ImageFormControl } from "../Controls/Web/ImageFormControl";
import { DataDefinition } from "../../rule-engine-core/Common/Data/DataDefinition";
import { BooleanDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/BooleanDataDefinition";
import { NumberDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { ObjectDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/ObjectDataDefinition";
import { StringDataDefinition } from "../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { TimelineFormControl } from "../Controls/Web/TimelineFormControl";
import { DataGridFormControl } from "../Controls/Web/DataGridFormControl";

import { ExpressionConfiguration } from "../../rule-engine-core/Expressions/ExpressionConfiguration";
import {
    FormRule,
    FormRuleChangeFocusData,
    FormRuleChangeValueData,
    FormRuleControlEnabledData,
    FormRuleControlVisibilityData,
    FormRuleExitFormData,
    FormRuleType,
    FormRuleValidationData,
} from "../Structure/FormRule";
import { getCombineSimpleRule, getEqualSimpleRule } from "../../Expressions/Testing/StringData";

// this is temporary code to create form definition.
// eventually, this form will be read in from JSON and written to JSON... even though I think that
// this might be useful pattern to create test scripts.

export function getFormData(): ExecutionData {
    let formData = new ExecutionData({
        firstName: "Carl",
        lastName: "Hewitt",
        testdata: "",
        age: 28,
    });

    return formData;
}

export function getFormConfig(): FormConfiguration {
    let heading = new HeadingFormControl();
    heading.text = "Person Information";
    heading.type = "h3";

    let label = new LabelFormControl();
    label.text = " Enter Information Below";

    let composite2 = new TextFormControl();
    composite2.label = "first name";
    composite2.valueName = "firstName";

    let composite3 = new TextFormControl();
    composite3.label = "last name";
    composite3.valueName = "lastName";

    let composite4 = new TextFormControl();
    composite4.label = "full name";
    composite4.valueName = "fullName";

    let compositeCheckbox = new CheckboxFormControl();
    compositeCheckbox.label = "Is Male";
    compositeCheckbox.valueName = "isMale";

    let numberBox = new NumberFormControl();
    numberBox.label = "Age";
    numberBox.valueName = "age";

    let compositeCheckList = new CheckboxListFormControl();
    compositeCheckList.label = "Software Used";
    compositeCheckList.valueName = "softwareUsed";
    compositeCheckList.list = ["Upwork", "Hubstaff", "Google Sites"];

    let selectBox = new SelectFormControl();
    selectBox.valueName = "selectLabel";
    selectBox.list = ["Pizza", "Cake", "Beer", "Candy"];

    let textbox = new MultiLineTextEditFormControl();
    textbox.valueName = "personDescription";
    textbox.rowMax = 20;
    textbox.rowMin = 7;
    textbox.placeholderText = "enter description of person";

    let radioButtonGroup = new RadioGroupFormControl();
    radioButtonGroup.valueName = "tester";
    radioButtonGroup.label = "Happy to be tester";
    radioButtonGroup.list = ["Yes", "No", "Indifferent"];

    let tagGroup = new TagGroupFormControl();
    tagGroup.label = "Categories";
    tagGroup.valueName = "Categories";
    tagGroup.list = ["Upwork", "Hubstaff", "Appglue"];

    let button = new ButtonFormControl();
    button.label = "Submit";
    let button2 = new ButtonFormControl();
    button.label = "Cancel";

    let link = new LinkFormControl();
    link.label = "Test Link";
    link.size = ButtonControlSize.STANDARD;

    let switchMe = new SwitchFormControl();
    switchMe.label = "isAlive";
    switchMe.valueName = "isAlive";

    let datePicker = new DatePickerFormControl();
    datePicker.label = "Birthday";
    datePicker.valueName = "birthday";

    let timePicker = new TimePickerFormControl();
    timePicker.label = "Favorite Time Of Day";
    timePicker.valueName = "favoriteTime";

    let slider = new SliderFormControl();
    slider.step = 10;
    slider.min = 0;
    slider.max = 100;
    slider.label = "Skill Level";
    slider.valueName = "skillLevel";

    let rating = new RatingFormControl();
    rating.label = "Please rate";
    rating.valueName = "rating";

    let buttonGroup = new ButtonGroupFormControl();
    buttonGroup.label = "Skills";
    buttonGroup.valueName = "skills";
    buttonGroup.list = ["React", "Typescript", "NodeJS"];

    let listEntry = new ListEntryFormControl();
    listEntry.label = "List";
    listEntry.valueName = "list";

    let inlineTextEdit = new InlineTextEditFormControl();
    inlineTextEdit.label = "Label";
    inlineTextEdit.valueName = "label";

    let multiInlineTextEdit = new MultiInlineTextEditFormControl();

    let valueSlider = new ValueSliderFormControl();
    let timeline = new TimelineFormControl();
    let imageControl = new ImageFormControl();

    let dataGrid = new DataGridFormControl();

    let colContainer = new XColumnContainer();
    colContainer.lineBetweenColumns = false;
    let container1 = new XColumnContainerColumn();

    container1.targetWidth = 20;
    container1.widthUnit = WidthUnitInterface.PERCENTAGE;
    colContainer.add(container1);

    [1, 2, 3].map((value) => {
        let composite = new TextFormControl();
        composite.label = "Facts " + value;
        composite.valueName = "otherdata_" + value;
        container1.add(composite);
        return value;
    });

    let container2 = new XColumnContainerColumn();

    container2.targetWidth = 70;
    container2.widthUnit = WidthUnitInterface.PERCENTAGE;
    colContainer.add(container2);

    [1, 2, 3].map((value) => {
        let composite = new TextFormControl();
        composite.label = "Other Facts " + value;
        composite.valueName = "otherdata2_" + value;
        container2.add(composite);
        return value;
    });

    let container3 = new XColumnContainerColumn();

    container3.targetWidth = 20;
    container3.overrideFormBorderSettings = DefaultOnOff.On;
    container3.showColumnBorder = true;
    container3.widthUnit = WidthUnitInterface.PERCENTAGE;
    colContainer.add(container3);

    [1, 2, 3].map((value) => {
        let composite = new TextFormControl();
        composite.label = "More Facts " + value;
        composite.valueName = "otherdata3_" + value;
        container3.add(composite);
        return value;
    });

    let container = new XStackContainer();
    container.add(label);
    container.add(composite2);
    container.add(composite3);
    container.add(composite4);
    container.add(switchMe);
    container.add(numberBox);
    container.add(compositeCheckbox);
    container.add(selectBox);
    container.add(textbox);
    container.add(radioButtonGroup);
    container.add(compositeCheckList);
    container.add(datePicker);
    container.add(timePicker);
    container.add(slider);
    container.add(rating);
    container.add(buttonGroup);
    container.add(listEntry);
    container.add(tagGroup);

    container.add(inlineTextEdit);
    container.add(multiInlineTextEdit);
    container.add(valueSlider);
    container.add(timeline);
    container.add(imageControl);

    container.add(dataGrid);

    let headingContainer = new XStackContainer();
    headingContainer.add(heading);

    let hstack1 = new XHStackContainer();
    hstack1.add(button);
    hstack1.add(button2);

    let hstack2 = new XHStackContainer();
    hstack2.add(link);

    let ui = new FormConfiguration([headingContainer, container, colContainer, hstack1, hstack2]);
    // todo: come back here
    //ui.setFormData(formData);

    // test code to start the process of writing out a json representation of the form
    let s = JSON.stringify(ui.getStorageData(), null, 2);

    let sasobj = JSON.parse(s);

    let newUI = new FormConfiguration();
    newUI.setStorageData(sasobj);
    return ui;
}

export const getDataDefinitionForRulePage = () => {
    let data = new DataDefinition();
    data.fields.push(new BooleanDataDefinition("isEmployee"));
    data.fields.push(new NumberDataDefinition("income"));

    data.fields.push(new NumberDataDefinition("divideValue"));
    data.fields.push(new NumberDataDefinition("divideBy"));

    let person = new ObjectDataDefinition("person");
    person.fields.push(new StringDataDefinition("name"));

    data.fields.push(person);

    return data;
};

export const getFormRules = () => {
    const validationRule = new FormRule(new ExpressionConfiguration());
    validationRule.expression = getEqualSimpleRule();
    validationRule.data = new FormRuleValidationData("Test Validation Message", "lastName");

    const changeFocusRule = new FormRule(new ExpressionConfiguration());
    changeFocusRule.expression = getEqualSimpleRule();
    changeFocusRule.ruleType = FormRuleType.CHANGE_FOCUS;
    changeFocusRule.data = new FormRuleChangeFocusData("age");

    const changeValueRule = new FormRule(new ExpressionConfiguration());
    changeValueRule.expression = getEqualSimpleRule();
    changeValueRule.ruleType = FormRuleType.CHANGE_VALUE;
    changeValueRule.data = new FormRuleChangeValueData("personDescription", getCombineSimpleRule());

    const controlEnabledRule = new FormRule(new ExpressionConfiguration());
    controlEnabledRule.expression = getEqualSimpleRule();
    controlEnabledRule.ruleType = FormRuleType.CONTROL_ENABLED;
    controlEnabledRule.data = new FormRuleControlEnabledData("isMale");

    const controlVisibilityRule = new FormRule(new ExpressionConfiguration());
    controlVisibilityRule.expression = getEqualSimpleRule();
    controlVisibilityRule.ruleType = FormRuleType.CONTROL_VISIBILITY;
    controlVisibilityRule.data = new FormRuleControlVisibilityData("isMale");

    const exitFormRule = new FormRule(new ExpressionConfiguration());
    exitFormRule.expression = getEqualSimpleRule();
    exitFormRule.ruleType = FormRuleType.EXIT_FORM;
    exitFormRule.data = new FormRuleExitFormData("person");

    return [validationRule, changeFocusRule, changeValueRule, controlEnabledRule, controlVisibilityRule, exitFormRule];
};
